import { makeStyles } from '@material-ui/core';

export const infoGraficosStyles = makeStyles({
  infoCard: {
    display: 'flex',
    justifyContent: 'left',
    backgroundColor: '#F1F0EF',
    marginTop: 120,
    border: 'none',
    borderRadius: 5,
    padding: 5,
  },
  iconInfo: {
    marginRight: 15,
    marginLeft: 20,
  },
  textInfo: {
    padding: 3,
  },
  semAcesso: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 120,
    padding: 5,
    flexDirection: 'column',

    position: 'absolute',
    zIndex: 99999,
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  },
  semAcessoIcon: {
    display: 'flex',
    backgroundColor: '#F1F0EF',
    border: 'none',
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center',
    width: 100,
    height: 100,
  },
});
